import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SummerNoteConfig } from 'src/app/common/summernote-config';
import { TermsConditionsService } from '../../services/terms-conditions/terms-conditions.service';
import { ActivatedRoute } from '@angular/router';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-terms-conditions-details',
    templateUrl: './terms-conditions-details.component.html',
    styleUrl: './terms-conditions-details.component.scss',
    standalone: false
})
export class TermsConditionsDetailsComponent implements OnInit {

  id: any;
  alertmsg: boolean = false;
  message: string = '';
  successImg: boolean = true;
  submitted: boolean = false;
  confirmMsg: string = 'تم الحفظ بنجاح';
  saveDialogRef: MatDialogRef<AlertBoxComponent>;


  summerNoteConfig = SummerNoteConfig.MAIN_CONFIG;
  termsConditionsFormGroup = new FormGroup({
    label: new FormControl(null, Validators.required),
    definitions: new FormControl(null, Validators.required),
    terms_and_conditions: new FormControl(null, Validators.required)
  });

  termsConditionsService = inject(TermsConditionsService);
  activeRoute = inject(ActivatedRoute);
  dialog = inject(MatDialog);

  ngOnInit(): void {
    this.id = this.activeRoute.snapshot.params['id'];
    if (this.id !== 'new') {
      this.getTermAndConditionById();
    }

    this.termsConditionsFormGroup.statusChanges.subscribe(status => {
      if (status === 'VALID' && this.submitted) {
        this.alertmsg = false;
        this.successImg = true;
        this.confirmMsg = 'تم الحفظ بنجاح';
      }
    });
  }

  getTermAndConditionById() {
    this.termsConditionsService.getTermAndConditionById(this.id).subscribe({
      next: (res) => {
        this.termsConditionsFormGroup.patchValue({
          label: res.label,
          definitions: res.definitions,
          terms_and_conditions: res.terms_and_conditions
        });
      }, error: (err) => {
        console.log(err);
      }
    });
  }

  save() {
    this.submitted = true;
    if (this.termsConditionsFormGroup.invalid) {
      this.alertmsg = true;
      this.message = 'يرجى ملء جميع الحقول المطلوبة.';
      this.termsConditionsFormGroup.markAllAsTouched();
      return;
    }
    if (this.id !== 'new') {
      this.updateTermAndCondition();
    } else {
      this.createTermAndCondition();
    }
  }

  updateTermAndCondition() {
    this.termsConditionsService.updateTermAndCondition(this.id, this.termsConditionsFormGroup.value).subscribe({
      next: (res) => {
        this.showAlertBox();
      }, error: (err) => {
        this.handleServerError(err);
      }
    });
  }


  createTermAndCondition() {
    this.termsConditionsService.createTermAndCondition(this.termsConditionsFormGroup.value).subscribe({
      next: (res) => {
        this.showAlertBox();
      }, error: (err) => {
        this.handleServerError(err);
      }
    });
  }
  
  handleServerError(error: any) {
    this.successImg = false;
    this.confirmMsg = 'حدث خطأ أثناء الحفظ. يرجى المحاولة مرة أخرى.';
    this.showAlertBox();
  }

  showAlertBox() {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: this.successImg,
        message: this.confirmMsg,
        button: 'تم',
        isBack: this.successImg
      },
    });
  }
}
